import * as Yup from 'yup';

import { isValidEmail } from '../../../lib/helpers/validation.helpers';

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Enter an association name'),
  ownerEmail: Yup.string()
    .required('Enter the owner email')
    .test('valid-email', 'Enter a valid email', (value) => isValidEmail(value || '')),
  timezone: Yup.object().nullable().required('Select a timezone'),
});
